import {neverland as $, render, html, useState, useEffect} from 'neverland';

const NumberField = $(function(f, fields, doc, updateDoc, isViewMode = false) {
	
	function updateField(ev) {

		// Convert value to number if an integer.
		let newVal = ev.target.value;

		updateDoc(f, newVal);
	}

	return html`
		<input
			class="field-${f} ${isViewMode ? 'disabled' : ''}"
			type="number"
			value="${doc.curr[f]}"
			?disabled="${isViewMode}"
			oninput="${isViewMode ? null : updateField}"
			min = "${fields[f].hasOwnProperty("min") ? fields[f].min : null}"
			max = "${fields[f].hasOwnProperty("max") ? fields[f].max : null}"
			></input>
		<label>
			${fields[f].title}
		</label>
	`;

});

export default NumberField;